import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import PriorityForm from './forms/priorityForm';
import PriorityFieldForm from './forms/priorityFieldForm';
import PriorityList from './lists/priorityList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import None from "./None";
import PropsProxy from "../layout/PropsProxy";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import {createComponent, fieldFilter, loadComponent} from "../../utils/components";
import debounce from "lodash-es/debounce";
import TextInput from "../form/TextInput";

export const PriorityListSelectorGrid = React.forwardRef((thisProps, ref) => {
    const props = {...thisProps};
    delete props.list_component_type;
    delete props.list_component_id;
    delete props.option_type;
    delete props.option_id_field;
    delete props.option_field;
    const field = thisProps.option_field || "priority";
    if (thisProps.list_component_type && thisProps.list_component_id && thisProps.option_type && thisProps.option_id_field) {
        props.onLoadCompleted = async (response) => {
            if (response && response.rows.length && !props.disabled) {
                let filter = [];
                if (thisProps.list_component_type && thisProps.list_component_id) {
                    filter = [
                        ...filter,
                        fieldFilter("list_component_type", thisProps.list_component_type),
                        fieldFilter("list_component_id", thisProps.list_component_id),
                    ];
                }
                if (thisProps.option_type && thisProps.option_id_field) {
                    filter = [
                        ...filter,
                        fieldFilter("option_type", thisProps.option_type),
                        fieldFilter("option_id", response.rows.map((row) => {
                            return row[thisProps.option_id_field];
                        }), "in"),
                    ];
                }
                const list = await loadComponent("componentlist", {
                    component: "priority",
                    itemsperpage: response.fullcount,
                    view: ["priority", "option_id"],
                    filter
                });
                list.items.map((row) => {
                    response.rows = response.rows.map((item) => {
                        if (item[thisProps.option_id_field] + "" === "" + row.option_id) {
                            item[field] = row.priority;
                        }
                        return item;
                    });
                });
            }
            return response;
        };
        props.columns[field] = {
            header: 'Sorrend',
            width: 1,
            operator: "=",
            renderer: !props.disabled ? (value, rowData, rowIndex, columnprops, parent) => {
                const saveChanges = debounce(async (field, value) => {
                    await createComponent("priority", {
                        data: {
                            list_component_type: thisProps.list_component_type,
                            list_component_id: thisProps.list_component_id,
                            option_type: thisProps.option_type,
                            option_id: rowData[thisProps.option_id_field],
                            priority: value
                        }
                    });
                    parent.refresh();
                }, 300);
                return <TextInput
                    label={false}
                    type="number"
                    placeholder={"Sorrend... Pl.: " + (rowIndex + 1) + "."}
                    name="priority"
                    value={value}
                    saveChanges={saveChanges}
                />
            } : null,
            filterable: true
        };
    }
    return (
        <PropsProxy
            {...props}
        >
            <SelectorGrid ref={ref} />
        </PropsProxy>
    );
});

class FieldEditor extends React.Component {
    render() {
        return <Fragment>
            {this.props.children}
            <div className="col-md-2">
                <div className="form-group">
                    <label className="control-label">&nbsp;</label>
                    {this.props.footer}
                </div>
            </div>
        </Fragment>;
    }
}

class priorityEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        let List = this.props.list || Box;
        let Editor = this.props.editor || BoxEditor;
        let Form = PriorityForm;
        if (this.props.presets.option_type) {
            Editor = FieldEditor;
            List = None;
            Form = PriorityFieldForm;
        }
        List = <List
            {...this.props}
            collapsed={this.props.collapsed || false}
            theme="default"
            header={"Url-ek"}
            footer={[
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={this.pristineForm}
                >
                    Új
                </Button>
            ]}
        >
            <PriorityList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
        </List>;
        Editor = <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header={"Url"}
                footer={[
                    <Button
                        key="0"
                        disabled={this.props.presets.option_type ? !this.props.dirty || this.props.isLoading : !this.props.presets.option_id || this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                        block={!!this.props.presets.option_type}
                        color="primary"
                        onClick={this.saveForm}
                    >
                        Kiemelés
                    </Button>
                ]}
            >
                <Form {...this.props} />
            </Editor>;
        if (this.props.presets.option_type) {
            return <div className="row">
                {Editor}
                {List}
            </div>;
        } else {
            return <Fragment>
                {List}
                {Editor}
            </Fragment>;
        }
    }
}

export default createEditor({componentName: "priority", WrappedComponent: priorityEditor});
